import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router-dom';
import warning from "./warning.jpg";
import logo from './../rcrm_logo.png';
import './FullScreenAlert.css';
import firebase from "firebase/app";
import "firebase/database";

const EnhancedFullScreenAlert = (props) => {
  const history = useHistory();
  const [minutes, setMinutes] = useState(parseInt(sessionStorage.getItem("exam_timer")) || 0);
  const [seconds, setSeconds] = useState(parseInt(sessionStorage.getItem("exam_sec")) || 0);

  useEffect(() => {
    // Timer logic - continue timer even on fullscreen alert
    const myInterval = setInterval(() => {
      setSeconds((prevSeconds) => {
        if (prevSeconds > 0) {
          const newSeconds = prevSeconds - 1;
          sessionStorage.setItem("exam_sec", newSeconds);
          return newSeconds;
        } else if (minutes > 0) {
          setMinutes((prevMinutes) => {
            const newMinutes = prevMinutes - 1;
            sessionStorage.setItem("exam_timer", newMinutes);
            sessionStorage.setItem("exam_sec", 59);
            return newMinutes;
          });
          return 59;
        } else {
          // Timer is up - prevent negative values and auto-submit exam
          console.log("🔥 FULLSCREEN ALERT: Timer expired, starting auto-submit");
          clearInterval(myInterval);
          sessionStorage.setItem("exam_timer", 0);
          sessionStorage.setItem("exam_sec", 0);
          console.log("⏰ Timer set to 0:00 in fullscreen alert");
          
          // Try multiple approaches to trigger auto-submit
          console.log("📡 DISPATCHING EVENT: examTimeUp from fullscreen alert");
          window.dispatchEvent(new CustomEvent('examTimeUp'));
          
          // Also set a flag in sessionStorage as backup
          console.log("💾 SETTING SESSIONSTORAGE FLAG: autoSubmitRequired");
          sessionStorage.setItem('autoSubmitRequired', 'true');
          sessionStorage.setItem('autoSubmitTimestamp', Date.now().toString());
          
          // Try to call autoSubmitExam directly if it exists on window
          if (window.autoSubmitExam) {
            console.log("🎯 DIRECT CALL: Found window.autoSubmitExam, calling directly");
            window.autoSubmitExam();
          } else {
            console.log("❌ DIRECT CALL: window.autoSubmitExam not found");
          }
          
          // Wait a bit for the event to be processed, then redirect
          setTimeout(() => {
            console.log("⏳ TIMEOUT REACHED: Redirecting from fullscreen alert after 1 second");
            // Check if we're still on the same page (event wasn't handled)
            // If the exam screen handled it, it would have redirected already
            history.push('/thankyou');
          }, 1000);
          
          return 0;
        }
      });
    }, 1000);

    return () => {
      clearInterval(myInterval);
    };
  }, [minutes, history]);

  const back2exam = () => {
    const elem = document.documentElement;
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    }
    
    // Wait a moment for fullscreen to activate, then redirect based on exam type
    setTimeout(() => {
      // Check which exam type the user was taking
      const examCode = sessionStorage.getItem("formvalid");
      const currentPath = window.location.pathname;
      
      // If we're on a dynamic exam path, redirect back to dynamic exam
      if (currentPath.includes('/dynamic-exam/') || examCode) {
        // Check if it's a dynamic exam by looking at the exam data
        firebase.database().ref(`TestPapers/${examCode}`).once('value')
          .then((snapshot) => {
            const examData = snapshot.val();
            if (examData && (examData.isDynamic || examData.dynamic)) {
              history.push(`/dynamic-exam/${examCode}`);
            } else if (examData && examData.isPshyco === 2) {
              history.push("/textbasedexamscreen");
            } else {
              history.push("/examscreen");
            }
          })
          .catch(() => {
            // Fallback to regular exam screen
            history.push("/examscreen");
          });
      } else {
        // Default fallback
        history.push("/examscreen");
      }
    }, 500);
  };

  return (
    <div className="App">
      <img src={logo} alt="logo" className="App-logo" />
      <div className="fullscreen-alert">
        <div className="alert-card">
          <img src={warning} alt="Warning" className="warning-icon" />
          <h3 className="alert-title">FULLSCREEN MODE EXIT DETECTED!</h3>
          <small className="alert-message">This action has been recorded for security purposes!</small>
          
          {/* Timer Display */}
          <div style={{ 
            background: '#fff3cd', 
            border: '2px solid #ffc107', 
            borderRadius: '8px', 
            padding: '15px', 
            margin: '20px 0',
            textAlign: 'center'
          }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#856404' }}>Time Remaining</h4>
            <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#856404' }}>
              {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
            </div>
          </div>

          <p className="alert-warning">
            <i>You must return to fullscreen mode to continue the examination. Timer continues running.</i>
          </p>
          
          <Button 
            variant='contained' 
            color='primary' 
            onClick={back2exam} 
            className="back-button"
            style={{ 
              fontSize: '16px', 
              padding: '12px 24px',
              fontWeight: 'bold',
              background: '#28a745',
              color: 'white'
            }}
          >
            Return to Fullscreen & Continue Examination
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EnhancedFullScreenAlert; 